import {BaseFormModel} from './base-form-model';

export class PaymentSummary extends BaseFormModel<PaymentSummary> {
    paymentsDate: Date;
    creditsTotal: number;
    tabChargesTips: number;
    tabChargesDonations: number;
    tabChargesPrincipal: number;
    tabChargesTotal: number;
    tabChargeSurcharges: number;
    tabChargeRefundsTips: number;
    tabChargeRefundsTotal: number;
    chargesTotal: number;
    tabCashTips: number;
    tabCashDonations: number;
    tabCashPrincipal: number;
    tabCashTotal: number;
    cashTotal: number;
    giftCardPaymentsTips: number;
    giftCardPaymentsDonations: number;
    giftCardPaymentsPrincipal: number;
    giftCardPaymentsTotal: number;
    giftCardPurchasesCount: number;
    giftCardPurchasesTotal: number;
    membershipPurchasesCount: number;
    membershipPurchasesTotal: number;
    tipsTotal: number;
    donationsTotal: number;
    paymentsTotal: number;
    paymentsAndCompsTotal: number;
}
